import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommonState {
    businessEmail: string | null;
    liferayRoute: string | null;
    industry: string[];
    industrySubcategory: string[];
}

const initialState: CommonState = {
    businessEmail: null,
    liferayRoute: null,
    industry: [],
    industrySubcategory: [],
};

const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setBusinessEmail(state, action: PayloadAction<string | null>) {
            state.businessEmail = action.payload;
        },
        setLiferayRoute(state, action: PayloadAction<string | null>) {
            state.liferayRoute = action.payload;
        },
        updateCommonValues(
            state,
            action: PayloadAction<Partial<CommonState>>
        ) {
            Object.assign(state, action.payload);
        },
        resetCommon() {
            return initialState;
        }
    }
});

export const {
    setBusinessEmail,
    setLiferayRoute,
    updateCommonValues,
    resetCommon
} = commonSlice.actions;

export default commonSlice.reducer;
